export default {
    EMITTER_TEST: 'emitter-test',
    UPDATE_NEWS_FEED: 'update-news-feed',
    HIDE_NEWS_FEED: 'hide-news-feed',
    INSTRUCTION_ACKED: 'instruction-acked',
    RETRY_INSTRUCTION_ACKED: 'retry-instruction-acked',
    TRANSITION_INSTRUCTION_ACKED: 'transition-instruction-acked',
    MANUAL_STAGE_DONE: 'manual-stage-done',
    PLAY_DOOR_ANIMATION: 'play-door-animation',
    INSPECT_ALGORITHM: 'inspect-algorithm',
    DATASET_VIEW_INSPECT: 'inspect-dataset',
    DATASET_VIEW_NEW_CV: 'dataset-new-cv',
    RESUME_TIMELINE: 'resume-timeline',
    SHOW_TOOLTIP: 'show-tooltip',
    STAGE_INCOMPLETE: 'stage-incomplete',
    DESTROY_TOOLTIP: 'destroy-tooltip',
    SHOW_ENDGAME_OVERLAY: 'show-endgame-overlay',
    RESIZE: 'resize',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    RETURN_CANDIDATE: 'return-candidate',
    DISPLAY_THIS_CV: 'display-this-cv',
    PERSON_HOVERED: 'person-hovered',
    CHANGE_SPOTLIGHT_STATUS: 'change-spotlight-status',
    MAKE_ML_PEOPLE_TALK: 'show-ml-speech-bubble',
    UPDATE_INSTRUCTIONS: 'update-instructions',
    HIDE_MANUAL_INSTRUCTIONS: 'hide-instructions',
    EXIT_TRANSITION_STAGE: 'exit-transition-stage',
    TITLE_STAGE_COMPLETED: 'title-stage-completed',
    REVEAL_REPLICA: 'reveal-next-replica',
    GREY_OUT_REPLICA: 'grey-out-previous-replica',
    HIDE_UNCHOSEN_BUTTONS: 'hide-unchosen-buttons',
    STATS_REVEAL_REPLICA: 'reveal-next-stats-replica',
    STATS_GREY_OUT_REPLICA: 'grey-out-previous-stats-replica',
    STATS_HIDE_UNCHOSEN_BUTTONS: 'hide-unchosen-stats-buttons',
    EMAIL_REPLY: 'email-reply',
    EXIT_STATS_CONVERSATION: 'exit-stats-conversation',
};
